import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivate, CanActivateChild, CanLoad, Route } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivateChild, CanActivate,CanLoad {
  constructor(private authService:AuthService) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const authenticate = !!this.authService.token();
    if (!authenticate) {
      this.authService.logoutRedirect();
    }
    return authenticate;
  }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.authService.checkAuth(state);
  }
  canLoad(route: Route): boolean {
    const token = !!this.authService.token();
    if (token) {
      return true; 
    } else {
     this.authService.loginRedirect();
      return false;
    }
  }
}